// Copyright (c) 2016 Deere & Company

import SearchResult from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import t from 'tcomb';

const SearchResults = t.list(SearchResult, 'SearchResults');

export const getDefaultState = () => new SearchResults([]);

export default SearchResults;



// WEBPACK FOOTER //
// ./src/product/search/state/search-results.js